import { FileRejection } from 'react-dropzone';
import { Box, Typography } from '../../../../base-components';
import { fileData, formatFileData } from '../../utils';
import { StyledPaper } from './ErrorFile.styles';

interface Props {
    fileRejections: Array<FileRejection>;
}

const ErrorFiles = (props: Props) => {
    const { fileRejections } = props;
    if (!fileRejections.length) {
        return null;
    }

    return (
        <StyledPaper variant="outlined">
            {fileRejections.map(({ file, errors }) => {
                const { path, size } = fileData(file);

                return (
                    <Box key={path} sx={{ my: 1 }}>
                        <Typography variant="subtitle2" noWrap>
                            {path} - {size ? formatFileData(size) : ''}
                        </Typography>

                        {errors.map((error) => (
                            <Box
                                key={error.code}
                                component="span"
                                sx={{ typography: 'caption' }}
                            >
                                - {error.message}
                            </Box>
                        ))}
                    </Box>
                );
            })}
        </StyledPaper>
    );
};

export default ErrorFiles;
